// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-main[data-v-4fdd58e2] {\n  /*50 = navbar  */\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n.fixed-header + .app-main[data-v-4fdd58e2] {\n  padding-top: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
